module.exports = __webpack_public_path__ + "static/media/one.bd54aefb.png";